import React from 'react';
import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';

export default function Filters({ filter, setFilter }) {
  const handleChange = (event, newFilter) => {
    if (newFilter !== null) setFilter(newFilter);
  };

  return (
    <Box>
      <ToggleButtonGroup value={filter} exclusive onChange={handleChange} size="small">
        <ToggleButton value="all">All</ToggleButton>
        <ToggleButton value="completed">Completed</ToggleButton>
        <ToggleButton value="pending">Pending</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
